export const LIGHT_OPACTIY = 0.1;
export const DEEP_OPACTIY = 0.2;
export const GRID_STEP = 27;
export const LABEL_SIZE = 9;
export const TICK_HEIGHT = 4;
export const SELECTED_TICK_HEIGHT = 10;

export const VIEPORT_TICK_OFFSET = 50;
export const RIGHT_PADDING = 7;
export const ESTIMATED_LABEL_SYMBOL_WIDTH = 5.5;
export const TOOLTIP_PADDING_X = 8;
